<template>
    <div class="loader">
        <div v-for="(dot, index) in dotCount"
             :key="index"
             class="dot"
             :style="{ animationDelay: `${index * animationDelay}s` }"></div>
    </div>
</template>

<script>
export default {
  name: "LoaderDots",
  props: {
    dotCount: {
      type: Number,
      default: 3, // Default to 3 dots
    },
    animationDelay: {
      type: Number,
      default: 0.4, // Default delay between animations
    },
  },
};
</script>

<style>
    .loader {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .dot {
        height: 10px;
        width: 10px;
        border-radius: 50%;
        transform: scale(0);
        background-color: transparent;
        animation: scaling 2.5s ease-in-out infinite;
        display: inline-block;
        margin-right: 0.3rem;
        animation: blink 1.2s infinite;
    }

    @keyframes blink {
        0%, 100% {
            transform: scale(0);
        }

        50% {
            transform: scale(1);
            background-color: #F0F0F0;
        }
    }

    /* Apply delays to each dot */
    .dot:nth-child(1) {
        animation-delay: 0s;
    }

    .dot:nth-child(2) {
        animation-delay: 0.4s;
    }

    .dot:nth-child(3) {
        animation-delay: 0.8s;
    }

    button:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
</style>
